(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["recogito"] = factory();
	else
		root["recogito"] = root["recogito"] || {}, root["recogito"]["Connections"] = factory();
})(self, function() {
return 